var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuestic-navbar',[_c('header-selector',{attrs:{"slot":"selector","isOpen":_vm.valueProxy},on:{"update:isOpen":function($event){_vm.valueProxy=$event}},slot:"selector"}),_vm._v(" "),_c('span',{staticClass:"i-vuestic",attrs:{"slot":"logo"},slot:"logo"},[_vm._v("Kagoshima PT")]),_vm._v(" "),_c('span',{attrs:{"slot":"center"},slot:"center"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c328931","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/app-navbar/AppNavbar.vue
// module id = JP8G
// module chunks = 71